import React from "react";
// import { SpinnerRoundFilled } from 'spinners-react';
import loaderPic from '../assets/images/Image-Loader.gif';

function LoaderMedium(props){
    return (
        // <SpinnerRoundFilled color={props.color ? props.color: '#d2342d'} size={props.size ? props.size: 45} />
        <div className="text-center">
            <img src={loaderPic} alt="Loading..." style={{width: props.size ? props.size: 45, height: props.size ? props.size: 45}}/>
        </div>
    )
}

export {LoaderMedium};